import { useGet } from "./requestAPI/apiGet"
import { AnalysisCampaignObject } from "../types/APITypes";

export const useGetAnalysisCampaigns = () => 
    useGet<AnalysisCampaignObject[]>({
        url: 'analytics-campaigns/get-analytics-campaigns'
    }); 

    


